export default __webpack_public_path__ + "static/media/lock.bd3b57cd.svg";